var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContaDeLuz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1409,
    height: 1366,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 284,
    width: 1409,
    height: 1366
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1290 -284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1643.15 1578.86C1643.15 1578.86 1365.43 1367.48 1300.12 1037.87 1234.47 707.91 1503.6 641.575 1661.36 529.87 1819.13 418.166 1877.21 292.37 2106.13 284.465 2334.69 276.903 2453.28 361.798 2535.77 526.09 2618.26 690.725 2662.6 859.484 2688.37 1024.46 2714.15 1189.44 2701.43 1321.08 2554.67 1386.73 2407.91 1452.38 2339.85 1423.51 2270.08 1499.12 2200.3 1575.08 1882.03 1746.59 1643.15 1578.86L1643.15 1578.86Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.15 1578.86C1643.15 1578.86 1365.43 1367.48 1300.12 1037.87 1234.47 707.91 1503.6 641.575 1661.36 529.87 1819.13 418.166 1877.21 292.37 2106.13 284.465 2334.69 276.903 2453.28 361.798 2535.77 526.09 2618.26 690.725 2662.6 859.484 2688.37 1024.46 2714.15 1189.44 2701.43 1321.08 2554.67 1386.73 2407.91 1452.38 2339.85 1423.51 2270.08 1499.12 2200.3 1575.08 1882.03 1746.59 1643.15 1578.86L1643.15 1578.86Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621.5 1574.5 2668.5 1574.5",
    stroke: "#BBBBBB",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.5 1574.5 2594.5 1574.5",
    stroke: "#BBBBBB",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.5 1574.5 1354.5 1574.5",
    stroke: "#BBBBBB",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.5 859.64C1519.5 859.64 1485.67 840.743 1483.3 883.691 1480.93 926.983 1474.5 1346.5 1474.5 1346.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.5 887.5C1465.5 887.5 1492.66 1088.39 1480.25 1342.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 867.681C1491.98 867.681 1478.92 875.939 1471.36 866.304 1463.8 856.669 1476.52 839.12 1465.52 831.55 1454.53 823.979 1435.63 835.679 1435.63 835.679 1435.63 835.679 1450.4 840.152 1449.72 848.067 1449.37 855.981 1442.16 859.078 1441.13 855.637 1440.1 852.196 1433.23 834.647 1421.2 841.873 1409.18 849.099 1407.46 860.455 1407.46 860.455 1407.46 860.455 1435.29 857.358 1436.66 868.025 1438.38 878.348 1425.32 866.304 1413.99 865.616 1402.65 864.928 1392.34 866.648 1393.03 873.53 1393.72 880.412 1392 891.768 1392 891.768 1392 891.768 1401.62 883.165 1414.33 883.853 1427.04 884.542 1426.36 892.456 1415.02 892.112 1403.68 891.768 1393.72 902.435 1393.72 902.435 1393.72 902.435 1404.02 920.328 1417.42 929.276 1430.82 938.222 1435.29 934.781 1437.01 928.243 1438.72 921.361 1434.94 903.811 1442.85 904.5 1450.75 904.844 1429.45 934.781 1439.75 936.502 1450.06 938.222 1458.31 935.469 1460.71 928.587L1463.46 921.705C1463.46 921.705 1460.02 904.156 1461.4 897.274 1463.12 890.392 1464.83 897.618 1466.55 905.532 1468.27 913.791 1469.64 933.405 1473.08 932.372 1476.52 931.34 1487.85 917.232 1490.26 911.382 1493.01 905.876 1475.48 888.671 1475.83 885.23 1476.17 881.789 1489.57 888.327 1491.63 891.768 1493.69 895.209 1495.75 900.026 1495.75 900.026 1495.75 900.026 1504 894.865 1504 878.692 1503.66 862.863 1491.63 867.681 1491.98 867.681L1491.98 867.681Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 867.681C1491.98 867.681 1478.92 875.939 1471.36 866.304 1463.8 856.669 1476.52 839.12 1465.52 831.55 1454.53 823.979 1435.63 835.679 1435.63 835.679 1435.63 835.679 1450.4 840.152 1449.72 848.067 1449.37 855.981 1442.16 859.078 1441.13 855.637 1440.1 852.196 1433.23 834.647 1421.2 841.873 1409.18 849.099 1407.46 860.455 1407.46 860.455 1407.46 860.455 1435.29 857.358 1436.66 868.025 1438.38 878.348 1425.32 866.304 1413.99 865.616 1402.65 864.928 1392.34 866.648 1393.03 873.53 1393.72 880.412 1392 891.768 1392 891.768 1392 891.768 1401.62 883.165 1414.33 883.853 1427.04 884.542 1426.36 892.456 1415.02 892.112 1403.68 891.768 1393.72 902.435 1393.72 902.435 1393.72 902.435 1404.02 920.328 1417.42 929.276 1430.82 938.222 1435.29 934.781 1437.01 928.243 1438.72 921.361 1434.94 903.811 1442.85 904.5 1450.75 904.844 1429.45 934.781 1439.75 936.502 1450.06 938.222 1458.31 935.469 1460.71 928.587L1463.46 921.705C1463.46 921.705 1460.02 904.156 1461.4 897.274 1463.12 890.392 1464.83 897.618 1466.55 905.532 1468.27 913.791 1469.64 933.405 1473.08 932.372 1476.52 931.34 1487.85 917.232 1490.26 911.382 1493.01 905.876 1475.48 888.671 1475.83 885.23 1476.17 881.789 1489.57 888.327 1491.63 891.768 1493.69 895.209 1495.75 900.026 1495.75 900.026 1495.75 900.026 1504 894.865 1504 878.692 1503.66 862.863 1491.63 867.681 1491.98 867.681L1491.98 867.681Z",
    fill: "#212121",
    fillRule: "evenodd",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.5 906.5C1434.92 895.718 1447.39 881.457 1457.5 874.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.5 919.5C1416.5 919.5 1418.62 916.228 1422.5 911.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.5 876.5C1463.5 876.5 1476.11 894.651 1478.5 913.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.5 887.548C1449.5 887.548 1452.38 885.487 1451.23 908.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.5 866.5C1458.5 866.5 1464.87 859.714 1461.53 846.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.5 877.5 1443.5 867.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.5 886.5C1437.5 886.5 1421.5 874.184 1411.5 873.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.72 833.753C1538.72 833.753 1538.03 852.772 1523.64 853.809 1508.9 854.847 1499.99 829.949 1484.91 835.828 1469.83 841.707 1468.46 869.024 1468.46 869.024 1468.46 869.024 1482.86 857.267 1490.4 863.146 1497.94 869.024 1496.22 878.361 1492.11 876.978 1488 875.595 1465.72 870.408 1465.03 887.352 1464.35 904.296 1474.29 913.978 1474.29 913.978 1474.29 913.978 1490.05 883.894 1501.71 889.427 1513.36 894.96 1492.11 899.801 1483.88 910.52 1475.32 921.586 1470.17 933.343 1477.37 937.147 1484.91 941.297 1494.85 950.633 1494.85 950.633 1494.85 950.633 1492.79 935.072 1502.05 922.624 1511.3 910.52 1518.84 916.399 1510.62 927.465 1502.05 938.53 1506.5 955.82 1506.5 955.82 1506.5 955.82 1531.52 957.549 1549 950.287 1566.82 943.026 1566.82 936.109 1561 929.885 1555.17 923.661 1535.64 915.362 1541.46 907.408 1547.29 899.801 1562.71 941.642 1571.28 932.306 1579.85 923.315 1582.59 912.941 1577.79 905.679L1572.99 898.418C1572.99 898.418 1553.11 890.118 1547.63 883.894 1541.8 877.67 1550.03 880.436 1559.63 884.24 1568.88 888.044 1589.44 900.146 1590.81 895.997 1592.18 891.847 1585.67 870.754 1581.9 864.183 1578.13 857.613 1549.34 863.492 1545.92 861.071 1542.49 858.651 1558.25 849.66 1563.05 850.006 1567.85 850.351 1574.02 851.389 1574.02 851.389 1574.02 851.389 1574.36 839.286 1558.25 828.566 1541.8 818.192 1538.72 833.753 1538.72 833.753L1538.72 833.753Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.72 833.753C1538.72 833.753 1538.03 852.772 1523.64 853.809 1508.9 854.847 1499.99 829.949 1484.91 835.828 1469.83 841.707 1468.46 869.024 1468.46 869.024 1468.46 869.024 1482.86 857.267 1490.4 863.146 1497.94 869.024 1496.22 878.361 1492.11 876.978 1488 875.595 1465.72 870.408 1465.03 887.352 1464.35 904.296 1474.29 913.978 1474.29 913.978 1474.29 913.978 1490.05 883.894 1501.71 889.427 1513.36 894.96 1492.11 899.801 1483.88 910.52 1475.32 921.586 1470.17 933.343 1477.37 937.147 1484.91 941.297 1494.85 950.633 1494.85 950.633 1494.85 950.633 1492.79 935.072 1502.05 922.624 1511.3 910.52 1518.84 916.399 1510.62 927.465 1502.05 938.53 1506.5 955.82 1506.5 955.82 1506.5 955.82 1531.52 957.549 1549 950.287 1566.82 943.026 1566.82 936.109 1561 929.885 1555.17 923.661 1535.64 915.362 1541.46 907.408 1547.29 899.801 1562.71 941.642 1571.28 932.306 1579.85 923.315 1582.59 912.941 1577.79 905.679L1572.99 898.418C1572.99 898.418 1553.11 890.118 1547.63 883.894 1541.8 877.67 1550.03 880.436 1559.63 884.24 1568.88 888.044 1589.44 900.146 1590.81 895.997 1592.18 891.847 1585.67 870.754 1581.9 864.183 1578.13 857.613 1549.34 863.492 1545.92 861.071 1542.49 858.651 1558.25 849.66 1563.05 850.006 1567.85 850.351 1574.02 851.389 1574.02 851.389 1574.02 851.389 1574.36 839.286 1558.25 828.566 1541.8 818.192 1538.72 833.753 1538.72 833.753L1538.72 833.753Z",
    fill: "#212121",
    fillRule: "evenodd",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.5 926.5C1526.7 910.771 1520.87 888.545 1521.56 873.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.5 945.501C1537.5 945.501 1536.14 941.375 1534.5 934.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.5 869.501C1528.5 869.501 1554.54 869.144 1574.5 879.501",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.5 891.239C1528.5 891.239 1528.85 885.984 1551.5 903.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.5 867.5C1514.5 867.5 1513.11 856.167 1497.5 851.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.5 884.5 1505.5 883.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.5 902.5C1520.5 902.5 1496.99 910.461 1489.5 920.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.5 959.5C1381.5 959.5 1463.15 1026.33 1454.92 1340.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.15 946.63C1473.15 946.63 1470.75 968.248 1453.62 967.905 1436.49 967.562 1428.61 938.395 1410.45 943.885 1392.29 949.375 1388.52 980.258 1388.52 980.258 1388.52 980.258 1405.99 967.905 1414.22 975.798 1422.44 983.347 1419.7 993.641 1414.9 991.582 1410.11 989.524 1385.09 981.631 1382.35 1001.19 1379.95 1020.75 1390.58 1032.76 1390.58 1032.76 1390.58 1032.76 1411.82 999.818 1424.5 1007.37 1437.17 1014.57 1412.5 1018 1401.88 1030.01 1391.26 1042.02 1383.72 1054.72 1391.95 1059.87 1400.17 1065.02 1410.79 1077.03 1410.79 1077.03 1410.79 1077.03 1410.11 1058.84 1421.76 1045.8 1433.75 1032.76 1441.97 1040.31 1431.01 1052.32 1420.38 1064.33 1423.47 1084.58 1423.47 1084.58 1423.47 1084.58 1451.91 1089.04 1473.15 1082.17 1494.39 1075.31 1495.08 1067.42 1488.91 1059.87 1482.74 1052.32 1460.82 1040.65 1468.35 1032.42 1475.89 1024.18 1489.6 1073.59 1500.22 1063.99 1511.18 1054.38 1514.95 1042.71 1510.15 1034.13L1505.36 1025.21C1505.36 1025.21 1483.43 1013.89 1477.26 1005.99 1471.09 998.445 1480.35 1002.56 1490.97 1007.71 1501.25 1012.86 1523.52 1028.99 1525.57 1024.18 1527.63 1019.38 1521.8 994.671 1518.03 987.121 1514.27 979.229 1480.35 983.347 1476.92 979.916 1473.49 976.827 1492.34 967.905 1497.82 968.591 1503.64 969.621 1510.5 971.337 1510.5 971.337 1510.5 971.337 1512.21 957.611 1494.39 943.542 1477.95 929.473 1473.15 946.63 1473.15 946.63L1473.15 946.63Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.15 946.63C1473.15 946.63 1470.75 968.248 1453.62 967.905 1436.49 967.562 1428.61 938.395 1410.45 943.885 1392.29 949.375 1388.52 980.258 1388.52 980.258 1388.52 980.258 1405.99 967.905 1414.22 975.798 1422.44 983.347 1419.7 993.641 1414.9 991.582 1410.11 989.524 1385.09 981.631 1382.35 1001.19 1379.95 1020.75 1390.58 1032.76 1390.58 1032.76 1390.58 1032.76 1411.82 999.818 1424.5 1007.37 1437.17 1014.57 1412.5 1018 1401.88 1030.01 1391.26 1042.02 1383.72 1054.72 1391.95 1059.87 1400.17 1065.02 1410.79 1077.03 1410.79 1077.03 1410.79 1077.03 1410.11 1058.84 1421.76 1045.8 1433.75 1032.76 1441.97 1040.31 1431.01 1052.32 1420.38 1064.33 1423.47 1084.58 1423.47 1084.58 1423.47 1084.58 1451.91 1089.04 1473.15 1082.17 1494.39 1075.31 1495.08 1067.42 1488.91 1059.87 1482.74 1052.32 1460.82 1040.65 1468.35 1032.42 1475.89 1024.18 1489.6 1073.59 1500.22 1063.99 1511.18 1054.38 1514.95 1042.71 1510.15 1034.13L1505.36 1025.21C1505.36 1025.21 1483.43 1013.89 1477.26 1005.99 1471.09 998.445 1480.35 1002.56 1490.97 1007.71 1501.25 1012.86 1523.52 1028.99 1525.57 1024.18 1527.63 1019.38 1521.8 994.671 1518.03 987.121 1514.27 979.229 1480.35 983.347 1476.92 979.916 1473.49 976.827 1492.34 967.905 1497.82 968.591 1503.64 969.621 1510.5 971.337 1510.5 971.337 1510.5 971.337 1512.21 957.611 1494.39 943.542 1477.95 929.473 1473.15 946.63 1473.15 946.63L1473.15 946.63Z",
    fill: "#212121",
    fillRule: "evenodd",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.5 1052.5C1452.4 1034.1 1447.97 1007.87 1450.02 990.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.5 1075.5C1461.5 1075.5 1460.17 1070.37 1458.5 1062.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.5 986.5C1457.5 986.5 1488.47 988.587 1510.5 1002.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.5 1011.24C1456.5 1011.24 1457.54 1005.23 1481.5 1027.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.5 982.5C1441.5 982.5 1440.81 969.167 1423.5 962.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.5 1002.5 1429.5 1000.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.5 1023.5C1445.5 1023.5 1417.17 1030.42 1407.5 1041.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.15 1158.63C1473.15 1158.63 1470.75 1180.25 1453.62 1179.91 1436.49 1179.56 1428.61 1150.39 1410.45 1155.88 1392.29 1161.38 1388.52 1192.26 1388.52 1192.26 1388.52 1192.26 1405.99 1179.91 1414.22 1187.8 1422.44 1195.35 1419.7 1205.64 1414.9 1203.58 1410.11 1201.52 1385.09 1193.63 1382.35 1213.19 1379.95 1232.75 1390.58 1244.76 1390.58 1244.76 1390.58 1244.76 1411.82 1211.82 1424.5 1219.37 1437.17 1226.57 1412.5 1230 1401.88 1242.01 1391.26 1254.02 1383.72 1266.72 1391.95 1271.87 1400.17 1277.02 1410.79 1289.03 1410.79 1289.03 1410.79 1289.03 1410.11 1270.84 1421.76 1257.8 1433.75 1244.76 1441.97 1252.31 1431.01 1264.32 1420.38 1276.33 1423.47 1296.58 1423.47 1296.58 1423.47 1296.58 1451.91 1301.04 1473.15 1294.17 1494.39 1287.31 1495.08 1279.42 1488.91 1271.87 1482.74 1264.32 1460.82 1252.65 1468.35 1244.42 1475.89 1236.18 1489.6 1285.59 1500.22 1275.99 1511.18 1266.38 1514.95 1254.71 1510.15 1246.13L1505.36 1237.21C1505.36 1237.21 1483.43 1225.89 1477.26 1217.99 1471.09 1210.44 1480.35 1214.56 1490.97 1219.71 1501.25 1224.86 1523.52 1240.99 1525.57 1236.18 1527.63 1231.38 1521.8 1206.67 1518.03 1199.12 1514.27 1191.23 1480.35 1195.35 1476.92 1191.92 1473.49 1188.83 1492.34 1179.91 1497.82 1180.59 1503.64 1181.62 1510.5 1183.34 1510.5 1183.34 1510.5 1183.34 1512.21 1169.61 1494.39 1155.54 1477.95 1141.47 1473.15 1158.63 1473.15 1158.63L1473.15 1158.63Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.15 1158.63C1473.15 1158.63 1470.75 1180.25 1453.62 1179.91 1436.49 1179.56 1428.61 1150.39 1410.45 1155.88 1392.29 1161.38 1388.52 1192.26 1388.52 1192.26 1388.52 1192.26 1405.99 1179.91 1414.22 1187.8 1422.44 1195.35 1419.7 1205.64 1414.9 1203.58 1410.11 1201.52 1385.09 1193.63 1382.35 1213.19 1379.95 1232.75 1390.58 1244.76 1390.58 1244.76 1390.58 1244.76 1411.82 1211.82 1424.5 1219.37 1437.17 1226.57 1412.5 1230 1401.88 1242.01 1391.26 1254.02 1383.72 1266.72 1391.95 1271.87 1400.17 1277.02 1410.79 1289.03 1410.79 1289.03 1410.79 1289.03 1410.11 1270.84 1421.76 1257.8 1433.75 1244.76 1441.97 1252.31 1431.01 1264.32 1420.38 1276.33 1423.47 1296.58 1423.47 1296.58 1423.47 1296.58 1451.91 1301.04 1473.15 1294.17 1494.39 1287.31 1495.08 1279.42 1488.91 1271.87 1482.74 1264.32 1460.82 1252.65 1468.35 1244.42 1475.89 1236.18 1489.6 1285.59 1500.22 1275.99 1511.18 1266.38 1514.95 1254.71 1510.15 1246.13L1505.36 1237.21C1505.36 1237.21 1483.43 1225.89 1477.26 1217.99 1471.09 1210.44 1480.35 1214.56 1490.97 1219.71 1501.25 1224.86 1523.52 1240.99 1525.57 1236.18 1527.63 1231.38 1521.8 1206.67 1518.03 1199.12 1514.27 1191.23 1480.35 1195.35 1476.92 1191.92 1473.49 1188.83 1492.34 1179.91 1497.82 1180.59 1503.64 1181.62 1510.5 1183.34 1510.5 1183.34 1510.5 1183.34 1512.21 1169.61 1494.39 1155.54 1477.95 1141.47 1473.15 1158.63 1473.15 1158.63L1473.15 1158.63Z",
    fill: "#212121",
    fillRule: "evenodd",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.5 1264.5C1452.4 1245.81 1447.97 1219.15 1450.02 1201.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.5 1286.5C1461.5 1286.5 1460.17 1281.37 1458.5 1273.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.5 1198.5C1457.5 1198.5 1488.47 1200.59 1510.5 1214.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.5 1223.24C1456.5 1223.24 1457.54 1217.23 1481.5 1239.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.5 1194.5C1441.5 1194.5 1440.81 1180.5 1423.5 1173.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.5 1214.5 1429.5 1211.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.5 1235.5C1445.5 1235.5 1417.17 1242.42 1407.5 1253.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.5 1111.01C1410.5 1111.01 1458.37 1286.8 1463.5 1341.5L1453.58 1019.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527.5 1084.85C1463.5 1073.53 1463.5 1341.5 1463.5 1341.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.64 1340.5C1471.64 1340.5 1434.82 933.5 1541.5 933.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.84 1076.61C1494.27 1067.01 1475.77 1067.01 1465.15 1091.71 1454.19 1116.75 1464.13 1112.29 1464.13 1112.29 1464.13 1112.29 1484.68 1105.77 1497.7 1101.31 1510.72 1096.85 1527.84 1086.22 1528.87 1092.74 1529.9 1099.26 1520.31 1105.77 1508.32 1107.83 1496.33 1109.89 1465.15 1118.81 1468.24 1125.33 1471.32 1131.84 1479.2 1151.4 1479.2 1151.4 1479.2 1151.4 1494.27 1138.36 1508.32 1129.79 1522.36 1121.21 1530.93 1124.3 1523.39 1134.25 1515.85 1143.85 1494.27 1154.83 1498.38 1167.86 1502.84 1180.9 1528.53 1197.02 1528.53 1197.02 1528.53 1197.02 1531.61 1169.92 1539.49 1161.35 1547.03 1152.77 1547.03 1162.38 1544.97 1177.47 1542.92 1192.56 1542.92 1197.02 1542.92 1197.02L1573.06 1208C1573.06 1208 1584.03 1191.88 1589.17 1186.39L1594.65 1180.9C1594.65 1180.9 1571.01 1160.32 1569.64 1147.28 1568.27 1134.25 1585.74 1147.28 1591.22 1149.34 1596.7 1151.4 1605.27 1166.83 1605.27 1166.83 1605.27 1166.83 1610.75 1141.79 1611.78 1133.22L1612.8 1124.64C1612.8 1124.64 1590.19 1116.06 1581.63 1116.06 1573.06 1116.06 1568.61 1122.58 1568.61 1114.01 1568.61 1105.43 1577.18 1099.94 1587.11 1100.97 1596.7 1102 1613.15 1107.49 1613.15 1107.49 1613.15 1107.49 1619.65 1102 1617.6 1085.88 1615.54 1069.75 1610.06 1069.75 1597.04 1073.87 1584.03 1078.33 1575.46 1087.93 1565.87 1087.93 1556.28 1087.93 1561.42 1075.93 1567.93 1072.84 1574.43 1069.75 1590.54 1063.24 1593.96 1061.86 1597.04 1060.83 1576.83 1045.74 1565.87 1043.34 1554.91 1041.28 1541.2 1048.83 1542.23 1059.46 1543.95 1082.1 1511.4 1086.22 1502.84 1076.61L1502.84 1076.61Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.5 1188.5C1573 1191.95 1573.5 1195.05 1573.5 1198.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551.5 1110.5C1558.96 1128.19 1567.77 1152.83 1571.5 1178.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.75 1101.5C1542.27 1089.99 1538.5 1083.22 1538.5 1083.22 1538.5 1083.22 1548.09 1078.82 1552.54 1070.36 1556.99 1061.9 1563.5 1057.5 1563.5 1057.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.5 1120.5C1500.5 1120.5 1538.5 1104.89 1538.5 1107.88",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.5 1099.5C1560.5 1099.5 1577.87 1091.5 1593.5 1091.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.5 1125.5C1554.5 1125.5 1544.81 1133.11 1533.73 1146.25 1522.65 1159.39 1518.5 1171.5 1518.5 1171.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.5 1130.31C1566.5 1130.31 1588.72 1124.18 1600.5 1134.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.88 983.097C1595.16 976.213 1582.06 975.869 1575.51 968.641 1568.96 961.412 1581.71 957.627 1588.26 960.38 1595.16 963.134 1610.67 971.05 1613.43 973.115 1616.53 974.836 1614.46 949.366 1608.95 939.729 1603.43 930.091 1588.61 924.584 1581.02 932.5 1565.17 949.022 1540.69 927.338 1542.41 914.258 1544.14 901.179 1532.07 887.411 1505.87 895.328 1480.02 903.588 1489.67 908.063 1489.67 908.063 1489.67 908.063 1508.29 919.421 1520.01 926.305 1531.73 933.189 1551.38 939.384 1547.24 944.547 1543.1 949.71 1531.73 946.612 1522.08 939.04 1512.77 931.468 1485.53 913.226 1482.78 920.109 1480.02 926.993 1470.37 945.236 1470.37 945.236 1470.37 945.236 1490.02 948.333 1505.87 953.152 1521.73 957.971 1524.83 966.919 1512.42 967.608 1500.01 968.296 1477.61 959.003 1470.71 970.706 1463.82 982.408 1468.64 1013.04 1468.64 1013.04 1468.64 1013.04 1491.39 997.553 1502.77 997.897 1514.15 998.241 1506.91 1004.44 1494.15 1012.7 1481.4 1020.96 1477.95 1024.06 1477.95 1024.06L1489.67 1054C1489.67 1054 1508.98 1051.59 1516.9 1051.94L1524.49 1052.62C1524.49 1052.62 1524.49 1020.96 1533.45 1011.66 1542.76 1002.37 1544.14 1024.06 1546.21 1029.56 1548.28 1035.07 1542.41 1051.59 1542.41 1051.59 1542.41 1051.59 1564.82 1039.2 1572.06 1034.38L1579.3 1029.56C1579.3 1029.56 1571.03 1006.5 1565.17 999.962 1559.65 993.422 1551.72 994.455 1558.27 988.604 1564.82 982.752 1574.47 985.85 1580.34 994.111 1585.85 1002.37 1592.4 1018.2 1592.4 1018.2 1592.4 1018.2 1600.67 1019.58 1611.71 1007.19 1622.39 994.455 1618.6 990.325 1606.88 983.097L1606.88 983.097ZM1504.15 1017.86C1495.53 1013.39 1516.22 1004.78 1516.22 1004.78 1523.8 1003.75 1512.77 1022.33 1504.15 1017.86ZM1518.63 977.59C1514.84 975.869 1526.21 972.083 1526.21 972.083 1542.07 974.836 1522.42 979.31 1518.63 977.59Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 1040.5C1502.05 1042.95 1499.95 1045.4 1497.5 1047.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.5 972.5C1540.35 989.841 1527.79 1012.73 1511.5 1032.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.5 964.5C1557.7 952.357 1560.47 944.5 1560.47 944.5 1560.47 944.5 1570.17 949.143 1579.52 946.643 1588.88 944.143 1596.5 946.286 1596.5 946.286",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.5 940.5C1508.5 940.5 1545.76 959.435 1543.39 961.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.5 972.5C1563.5 972.5 1581.48 980.1 1591.5 991.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.5 984.663C1539.5 984.663 1527.42 982.18 1510.5 982.535 1493.58 982.889 1481.5 987.5 1481.5 987.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.5 996.5C1544.5 996.5 1563.83 1009.46 1563.5 1025.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.13 1133.33C1428.5 1127.84 1418.19 1127.49 1413.03 1121.65 1407.87 1115.82 1417.84 1112.72 1423.34 1115.13 1428.84 1117.19 1441.22 1123.71 1443.63 1125.09 1446.04 1126.46 1444.32 1105.86 1439.85 1098.3 1435.38 1090.74 1423.34 1085.94 1417.5 1092.46 1404.78 1105.86 1385.18 1088.34 1386.21 1078.04 1387.58 1067.73 1377.96 1056.4 1356.98 1062.92 1336.01 1069.45 1343.92 1073.23 1343.92 1073.23 1343.92 1073.23 1358.7 1082.16 1368.33 1088 1377.96 1093.49 1393.43 1098.3 1390.33 1102.42 1386.9 1106.54 1377.96 1104.14 1370.39 1097.96 1362.83 1091.77 1340.82 1077.35 1338.76 1082.84 1336.35 1088.34 1328.79 1103.11 1328.79 1103.11 1328.79 1103.11 1344.61 1105.51 1357.33 1109.29 1370.05 1113.41 1372.46 1120.28 1362.83 1120.97 1352.86 1121.65 1334.98 1114.1 1329.13 1123.37 1323.29 1132.64 1327.41 1157.37 1327.41 1157.37 1327.41 1157.37 1345.64 1145.01 1354.92 1145.01 1364.2 1145.01 1358.36 1150.16 1348.04 1157.03 1337.73 1163.55 1334.98 1165.96 1334.98 1165.96L1344.26 1190C1344.26 1190 1359.73 1187.94 1365.92 1188.28L1372.11 1188.63C1372.11 1188.63 1372.11 1163.21 1379.33 1155.66 1386.55 1148.1 1387.93 1165.62 1389.3 1170.08 1391.02 1174.55 1386.21 1187.94 1386.21 1187.94 1386.21 1187.94 1404.09 1177.98 1409.93 1174.2L1415.78 1170.42C1415.78 1170.42 1408.9 1151.88 1404.43 1146.73 1399.96 1141.57 1393.77 1142.26 1398.93 1137.8 1404.09 1133.33 1412 1135.74 1416.47 1142.26 1420.94 1148.79 1426.09 1161.49 1426.09 1161.49 1426.09 1161.49 1432.97 1162.52 1441.57 1152.56 1450.51 1142.26 1447.76 1138.83 1438.13 1133.33L1438.13 1133.33ZM1355.61 1161.15C1348.73 1157.72 1365.24 1150.85 1365.24 1150.85 1371.42 1149.82 1362.83 1164.59 1355.61 1161.15ZM1367.3 1128.52C1364.2 1127.15 1373.14 1124.06 1373.14 1124.06 1386.21 1126.81 1370.39 1130.24 1367.3 1128.52Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.5 1179.5C1354.63 1181.75 1352.38 1183.63 1350.5 1185.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.5 1125.5C1385.95 1139.66 1375.6 1157.62 1362.5 1173.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.5 1118.5C1399.58 1108.9 1401.62 1102.5 1401.62 1102.5 1401.62 1102.5 1409.43 1106.41 1416.91 1104.28 1424.38 1102.14 1430.5 1103.92 1430.5 1103.92",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.5 1099.5C1359.5 1099.5 1389.42 1114.77 1387.4 1116.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.5 1125.5C1403.5 1125.5 1418.36 1131.3 1426.5 1140.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.5 1135.34C1384.5 1135.34 1374.96 1133.18 1361.33 1133.54 1347.7 1133.9 1338.5 1137.5 1338.5 1137.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.5 1144.5C1387.5 1144.5 1403.5 1154.65 1403.5 1167.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.2 1250.33C1520.59 1244.84 1510.28 1244.49 1505.13 1238.65 1499.98 1232.82 1509.94 1229.72 1515.44 1232.13 1520.93 1234.53 1533.3 1240.71 1535.7 1242.09 1538.1 1243.46 1536.39 1222.86 1531.92 1215.3 1527.46 1207.74 1515.44 1202.94 1509.6 1209.46 1496.89 1222.86 1477.31 1205.34 1478.34 1195.04 1479.37 1184.73 1470.1 1173.4 1449.15 1179.92 1428.2 1186.45 1436.1 1190.23 1436.1 1190.23 1436.1 1190.23 1450.86 1199.16 1460.48 1205 1470.1 1210.49 1485.55 1215.3 1482.12 1219.42 1478.68 1223.54 1469.75 1221.14 1462.2 1214.96 1454.64 1208.77 1432.66 1194.35 1430.6 1199.84 1428.2 1205.34 1420.64 1220.11 1420.64 1220.11 1420.64 1220.11 1436.44 1222.51 1449.15 1226.29 1461.86 1230.07 1464.26 1237.28 1454.64 1237.97 1444.68 1238.65 1426.82 1231.1 1420.98 1240.37 1415.49 1249.99 1419.27 1274.37 1419.27 1274.37 1419.27 1274.37 1437.47 1262.01 1446.74 1262.01 1456.02 1262.01 1450.18 1267.16 1439.87 1274.03 1429.57 1280.9 1426.82 1282.96 1426.82 1282.96L1436.1 1307C1436.1 1307 1451.55 1304.94 1457.73 1305.28L1463.92 1305.63C1463.92 1305.63 1463.92 1280.21 1471.13 1272.66 1478.34 1265.1 1479.72 1282.62 1481.09 1287.08 1482.81 1291.54 1478 1304.94 1478 1304.94 1478 1304.94 1495.86 1294.98 1501.7 1291.2L1507.54 1287.42C1507.54 1287.42 1500.67 1268.88 1496.2 1263.73 1491.74 1258.57 1485.55 1259.26 1490.71 1254.8 1495.86 1250.33 1503.76 1252.74 1508.22 1259.26 1512.69 1265.79 1517.84 1278.49 1517.84 1278.49 1517.84 1278.49 1524.71 1279.52 1533.3 1269.56 1542.57 1259.26 1539.82 1255.83 1530.2 1250.33ZM1447.77 1278.15C1440.9 1274.72 1457.39 1267.85 1457.39 1267.85 1463.57 1266.82 1454.99 1281.59 1447.77 1278.15ZM1459.79 1245.52C1456.7 1244.15 1465.63 1241.06 1465.63 1241.06 1478.34 1243.46 1462.54 1247.24 1459.79 1245.52Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.5 1296.5C1446.63 1298.75 1444.38 1300.63 1442.5 1302.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.5 1242.5C1476.95 1256.66 1466.6 1274.61 1453.5 1290.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.5 1235.5C1490.69 1225.9 1492.79 1219.5 1492.79 1219.5 1492.79 1219.5 1500.83 1223.41 1508.52 1221.28 1516.21 1219.14 1522.5 1220.92 1522.5 1220.92",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.5 1216.5C1450.5 1216.5 1481.49 1231.77 1479.4 1233.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.5 1242.5C1495.5 1242.5 1509.72 1248.3 1517.5 1257.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.5 1252.34C1476.5 1252.34 1466.75 1250.18 1452.83 1250.54 1438.9 1250.9 1429.5 1254.5 1429.5 1254.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.5 1261.5C1480.5 1261.5 1495.5 1272.09 1495.5 1285.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.84 953.841C1399.84 953.841 1387.77 962.504 1380.19 953.841 1372.61 945.177 1383.29 927.503 1372.61 920.918 1361.92 914.334 1344.34 926.81 1344.34 926.81 1344.34 926.81 1358.47 929.929 1358.47 937.899 1358.47 945.87 1351.92 948.989 1350.89 945.523 1349.85 942.404 1342.27 925.77 1331.24 933.394 1320.21 941.018 1319.18 952.108 1319.18 952.108 1319.18 952.108 1345.37 947.603 1347.44 957.653 1349.51 967.356 1336.41 956.613 1325.72 956.613 1314.69 956.613 1305.04 958.692 1306.08 965.277 1307.11 971.861 1306.08 982.951 1306.08 982.951 1306.08 982.951 1314.69 974.287 1326.76 974.287 1338.82 974.287 1338.82 981.911 1327.79 981.911 1316.76 981.911 1308.14 993.001 1308.14 993.001 1308.14 993.001 1319.18 1009.29 1331.93 1017.26 1345.03 1024.88 1349.17 1021.76 1350.54 1015.18 1351.58 1008.6 1347.44 992.307 1355.03 992.307 1362.61 992.307 1343.99 1021.76 1353.99 1022.8 1363.64 1023.84 1371.23 1020.72 1373.64 1014.14L1375.71 1007.56C1375.71 1007.56 1371.23 991.268 1372.61 984.683 1373.64 978.099 1375.71 984.683 1378.12 992.307 1380.19 999.932 1382.6 1018.65 1385.71 1017.61 1388.81 1016.57 1398.8 1002.36 1400.87 996.813 1402.94 991.268 1385.71 976.02 1385.71 972.901 1385.71 969.435 1398.8 974.98 1400.87 978.446 1402.94 981.565 1405.35 986.07 1405.35 986.07 1405.35 986.07 1412.94 980.525 1411.9 965.277 1410.52 948.642 1399.84 954.187 1399.84 953.841L1399.84 953.841Z",
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.5 994.5C1347.01 984.065 1357.94 969.457 1367.5 962.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.5 1006.5C1330.5 1006.5 1332.9 1003.64 1336.5 999.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.5 964.5C1373.5 964.5 1386.44 980.806 1389.5 998.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.5 975.551C1360.5 975.551 1363.5 973.556 1363.5 994.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.5 954.5C1367.5 954.5 1374.71 947.815 1369.78 935.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.5 965.5 1353.5 956.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.5 975.5C1349.5 975.5 1333.42 964.5 1323.5 964.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.5 1574.5 1425.5 1574.5 1435.83 1337.5 1498.83 1337.5 1509.5 1574.5Z",
    stroke: "#212121",
    strokeWidth: 6.875,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.5 451.5 1362.5 451.5 1362.5 711.5 1556.5 711.5 1556.5 451.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.5 465.5 1372.5 465.5 1372.5 697.5 1546.5 697.5 1546.5 465.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.5 528.5 1419.5 528.5 1419.5 634.5 1498.5 634.5 1498.5 528.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.5 536.5 1711.5 501.5 1664.5 501.5 1664.5 536.5 1711.5 536.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2399.5 440.5 1661.5 440.5 1661.5 1372.5 2399.5 1372.5 2399.5 440.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.5 1232.5 1810.5 1232.5 1810.5 1315.5 1833.5 1315.5 1833.5 1232.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.5 1215.5 1850.5 1215.5 1850.5 1315.5 1874.5 1315.5 1874.5 1215.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915.5 1196.5 1891.5 1196.5 1891.5 1315.5 1915.5 1315.5 1915.5 1196.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955.5 1184.5 1932.5 1184.5 1932.5 1315.5 1955.5 1315.5 1955.5 1184.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.5 1223.5 1973.5 1223.5 1973.5 1315.5 1996.5 1315.5 1996.5 1223.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037.5 1156.5 2013.5 1156.5 2013.5 1315.5 2037.5 1315.5 2037.5 1156.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2078.5 1188.5 2054.5 1188.5 2054.5 1315.5 2078.5 1315.5 2078.5 1188.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.5 1184.5 2095.5 1184.5 2095.5 1315.5 2118.5 1315.5 2118.5 1184.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2159.5 1160.5 2135.5 1160.5 2135.5 1315.5 2159.5 1315.5 2159.5 1160.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200.15 1166.5 2176.5 1166.5 2176.5 1315.5 2200.5 1315.5 2200.5 1166.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2241.5 1159.5 2217.5 1159.5 2217.5 1315.5 2241.5 1315.5 2241.5 1159.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2281.5 1153.5 2258.5 1153.5 2258.5 1315.5 2281.5 1315.5 2281.5 1153.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2322.5 1213.5 2298.5 1213.5 2298.5 1315.5 2322.5 1315.5 2322.5 1213.5Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.5 1315.5 1733.5 1315.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.5 1275.5 1733.5 1275.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.5 1234.5 1733.5 1234.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.5 1194.5 1733.5 1194.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.5 1153.5 1733.5 1153.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.49 522.446C1797.49 499.561 1777.63 481.047 1753.54 482.59 1733.68 483.876 1717.27 499.561 1715.68 518.846 1714.62 529.902 1718.33 540.188 1724.95 547.901 1731.03 554.844 1734.21 563.844 1734.21 573.1L1734.21 578.5 1778.42 578.5 1778.42 573.1C1778.42 563.844 1781.6 555.101 1787.69 547.901 1794.05 541.216 1797.75 532.217 1797.49 522.446L1797.49 522.446Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#DFFF02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.5 578.5 1734.5 578.5 1734.5 588.5 1778.5 588.5 1778.5 578.5Z",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.5 588.5 1778.5 588.5 1778.5 593.866C1778.5 597.085 1775.87 599.5 1772.97 599.5L1740.03 599.5C1736.87 599.5 1734.5 596.817 1734.5 593.866L1734.5 588.5Z",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.5 599.5 1773.5 599.5 1773.5 604.378C1773.5 607.305 1770.86 609.5 1767.96 609.5L1746.04 609.5C1742.88 609.5 1740.5 607.061 1740.5 604.378L1740.5 599.5Z",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.5 522.5 1822.5 522.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.5 522.5 1708.5 522.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.5 476.5 1755.5 458.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.5 489.5 1802.5 477.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.5 568.5 1722.5 555.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.5 489.5 1708.5 477.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.5 568.5 1790.5 556.5",
    stroke: "#212121",
    strokeWidth: 2.57822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2197.5 755.826 2197.5 705.5 2351.5 705.5 2351.5 887.5 2303.03 887.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.5 749.5 2322.5 749.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.5 770.5 2322.5 770.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.5 791.5 2322.5 791.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2262.5 812.5 2322.5 812.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.5 812.5 2250.5 812.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.5 832.5 2322.5 832.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.5 853.5 2322.5 853.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.5 853.5 2282.5 853.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.32 536.61C1923.95 537.306 1921.21 538 1917.44 538 1906.48 538 1901 531.053 1901 522.021 1901 511.253 1908.53 505 1918.12 505 1921.89 505 1924.63 505.695 1926 506.389L1924.63 511.947C1923.26 511.253 1921.21 510.905 1918.81 510.905 1913.33 510.905 1908.88 514.379 1908.88 521.326 1908.88 527.579 1912.64 531.747 1918.81 531.747 1920.86 531.747 1923.26 531.4 1924.63 530.705L1925.32 536.61 1925.32 536.61Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957 521.326C1957 531.747 1950.86 538 1941.66 538 1932.45 538 1927 530.705 1927 521.674 1927 512.642 1933.14 505 1942.34 505 1951.2 505.347 1957 512.642 1957 521.326ZM1934.5 521.674C1934.5 527.926 1937.57 532.442 1942 532.442 1946.43 532.442 1949.5 527.926 1949.5 521.674 1949.5 515.768 1946.77 510.905 1942 510.905 1937.23 510.905 1934.5 515.421 1934.5 521.674L1934.5 521.674Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961 537.319 1961 506 1969.32 506 1975.91 517.574C1977.99 520.979 1979.72 524.724 1981.11 528.468L1981.11 528.468C1980.76 524.383 1980.41 519.958 1980.41 515.532L1980.41 506.341 1987 506.341 1987 537.66 1979.37 537.66 1972.44 525.745C1970.71 522.34 1968.63 518.255 1966.89 514.851L1966.89 514.851C1967.24 518.936 1967.24 523.362 1967.24 528.468L1967.24 538 1961 538Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.45 511.978 1991 511.978 1991 506 2015 506 2015 511.978 2006.55 511.978 2006.55 538 1999.45 538 1999.45 511.978Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2022.32 529.652 2020.25 538 2013 538 2022.67 506 2031.99 506 2042 538 2034.4 538 2031.99 529.652 2022.32 529.652ZM2030.26 524.435 2028.19 517.826C2027.5 516.087 2027.16 513.652 2026.46 511.565L2026.46 511.565C2026.12 513.305 2025.43 515.739 2025.08 517.826L2023.01 524.435 2030.26 524.435 2030.26 524.435Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055 506.681C2057.67 506.34 2061 506 2064.33 506 2070 506 2074 507.021 2077 509.404 2080.33 511.787 2082 515.532 2082 521.319 2082 527.447 2080 531.532 2077 533.915 2073.67 536.638 2069 538 2063 538 2059.33 538 2057 537.66 2055 537.66L2055 506.681 2055 506.681ZM2062 532.213C2062.67 532.213 2063.67 532.213 2064.33 532.213 2070.67 532.213 2074.67 528.809 2074.67 521.319 2074.67 514.851 2071 511.447 2065 511.447 2063.33 511.447 2062.33 511.447 2062 511.787L2062 532.213Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2105.28 524.435 2093.9 524.435 2093.9 532.087 2107 532.087 2107 538 2087 538 2087 506 2106.66 506 2106.66 511.913 2093.9 511.913 2093.9 518.522 2105.62 518.522 2105.62 524.435 2105.28 524.435Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121 506 2128 506 2128 531.209 2140 531.209 2140 537 2121 537 2121 506 2121 506Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2149.93 506 2149.93 524.043C2149.93 529.49 2152.01 532.213 2155.83 532.213 2159.64 532.213 2161.72 529.49 2161.72 524.043L2161.72 506 2169 506 2169 523.702C2169 533.234 2164.15 538 2155.83 538 2147.51 538 2143 533.575 2143 523.702L2143 506.341 2149.93 506 2149.93 506Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2172 534.174 2187.49 512.261 2187.49 511.913 2173.41 511.913 2173.41 506 2197 506 2197 510.174 2181.86 531.739 2181.86 532.087 2197 532.087 2197 538 2172 538 2172 534.174Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2028.5 1138.5 2078.5 1138.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1873.5 1138.5 1997.5 1138.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.5 755.826 1696.5 705.5 2174.5 705.5 2174.5 887.5 2023.68 887.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.5 887.5 1696.5 887.5 1696.5 782.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.5 956.996 1692.5 907.5 2351.5 907.5 2351.5 1086.5 2143.57 1086.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2105.5 1087.5 1691.5 1087.5 1691.5 984.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.5 951.5 2048.5 951.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.5 972.5 2048.5 972.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.5 1014.5 1943.5 1014.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.5 1055.5 1856.5 1055.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.5 1055.5 1915.5 1055.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.5 1037.5 2133.5 1037.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1682,
    y: 671,
    width: 573,
    height: 434,
    fill: "#FFFFFF",
    fillOpacity: 0.901961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829.5 764.335 1829.5 673.5 2230.5 673.5 2230.5 1001.5 2104.2 1001.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080.5 1001.5 1829.5 1001.5 1829.5 826.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.5 753.5 2080.5 753.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.5 803.5 2080.5 803.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.5 853.5 2080.5 853.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1959.5 903.5 2079.5 903.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.5 903.5 1934.5 903.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.5 953.5 2080.5 953.5",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Kumbh Sans,Kumbh Sans_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 34,
    transform: "matrix(1 0 0 1 1872.63 747)"
  }, "Titular"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Kumbh Sans,Kumbh Sans_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 34,
    transform: "matrix(1 0 0 1 1872.01 795)"
  }, "CPF/CNPJ"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Kumbh Sans,Kumbh Sans_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 34,
    transform: "matrix(1 0 0 1 1872.63 847)"
  }, "Endere\xE7o"), /*#__PURE__*/React.createElement("path", {
    d: "M2058.81 574.396C1907.69 540.369 1757.95 635.575 1724.29 787.149 1690.63 938.723 1785.42 1088.58 1936.19 1122.6 2087.31 1156.63 2237.05 1061.43 2270.71 909.852 2304.37 758.622 2209.58 608.422 2058.81 574.396ZM1946.5 1076.55C1820.8 1048.36 1741.8 923.256 1769.97 797.116 1798.13 670.977 1922.8 591.925 2048.5 620.108 2174.2 648.292 2253.2 773.401 2225.03 899.541 2196.87 1025.68 2072.2 1105.08 1946.5 1076.55Z",
    stroke: "#212121",
    strokeWidth: 3.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2554.22 1455.8C2545.28 1453.74 2536.34 1449.28 2529.12 1442.4L2195.96 1130.37C2174.3 1110.1 2173.27 1075.73 2193.55 1054.09 2213.84 1032.44 2247.88 1031.06 2269.88 1051.68L2603.04 1363.71C2624.7 1383.98 2625.73 1418.35 2605.45 1440 2591.69 1454.43 2572.1 1459.58 2554.22 1455.8Z",
    fill: "#212121",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContaDeLuz);
export default __webpack_public_path__ + "static/media/conta-de-luz.8a4ed79ab1557af87e87cc6cca26c270.svg";
export { ForwardRef as ReactComponent };